const CHANGE_PASSWORD_STORAGE_KEY = 'forceChangePassword';

export class ForceChangePassword {
  /**
   * 
   * @param shouldChangePassword force_change_password from auth response
   */
  static setChangePasswordValue(shouldChangePassword: boolean) {
    sessionStorage.setItem(CHANGE_PASSWORD_STORAGE_KEY, String(shouldChangePassword));
  }

  static getChangePasswordValue() {
    return sessionStorage.getItem(CHANGE_PASSWORD_STORAGE_KEY) === 'true';
  }

  static clearChangePasswordValue() {
    sessionStorage.removeItem(CHANGE_PASSWORD_STORAGE_KEY);
  }
}
